import { useNavigate } from 'react-router-dom'

export const TEST_PRINTER_URL = '/assembly/printer/test-printer'

export const useGoToTestPrinter = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(TEST_PRINTER_URL)
    }
  }
}
